import { nameof } from 'ts-simple-nameof'
import * as yup from 'yup'
import type { BaseParamsDto, BaseParamsVehicleDto } from '../dtos'
import { RiskVariant } from '../enums'

export const BaseParamsValidationRuleObject = {
    // INSURERS
    [nameof<BaseParamsDto>(x => x.insurers)]: yup
        .array()
        .nullable()
        .min(1, 'Vyberte pojišťovnu')
}

export const VehicleBaseParamsValidationRuleObject = {
    // SPOL
    [nameof<BaseParamsVehicleDto>(x => x.spol)]: yup
        .array()
        .nullable()
        .when(nameof<BaseParamsVehicleDto>(x => x.hav), {
            is: (hav?: number[]) => {
                // spoluucast povinna pokud je HAV                
                const havArray = hav ? (Array.isArray(hav) ? hav : [hav]) : []

                return (havArray.length > 0 ? havArray[0] : RiskVariant.WithoutHAV) != RiskVariant.WithoutHAV
            },
            then: () => yup.array().min(1, 'Vyberte spoluúčast'),
            otherwise: () => yup.array().optional()
        }),

    // POV
    [nameof<BaseParamsVehicleDto>(x => x.pov)]: yup
        .array()
        .nullable()
        .when(nameof<BaseParamsVehicleDto>(x => x.hav), {
            is: (hav?: number[]) => {
                // spoluucast povinna pokud je HAV                
                const havArray = hav ? (Array.isArray(hav) ? hav : [hav]) : []

                return (havArray.length > 0 ? havArray[0] : RiskVariant.WithoutHAV) == RiskVariant.WithoutHAV
            },
            then: () => yup.array().min(1, 'Vyberte alespoň jedno hlavní krytí'),
            otherwise: () => yup.array().optional()
        }),

    ...BaseParamsValidationRuleObject
}

export const VehicleBaseParamsValidationSchema = yup.object().shape(VehicleBaseParamsValidationRuleObject) as any